import React, { useState } from 'react';

const TOOL_LABELS = {
    list_zones: 'Listar Zonas',
    create_zone: 'Criar Zona',
    get_dns_records: 'Listar Registros DNS',
    search_records_by_content: 'Buscar Registros',
    create_dns_record: 'Criar Registro DNS',
    update_dns_record: 'Atualizar Registro',
    delete_dns_record: 'Deletar Registro',
    update_record_ttl: 'Alterar TTL',
    toggle_proxy: 'Alternar Proxy',
    check_dns_propagation: 'Verificar Propagacao'
};

const TOOL_ICONS = {
    list_zones: '\uD83D\uDDC2\uFE0F',
    create_zone: '\u2795',
    get_dns_records: '\uD83D\uDCCB',
    search_records_by_content: '\uD83D\uDD0D',
    create_dns_record: '\u2795',
    update_dns_record: '\u270F\uFE0F',
    delete_dns_record: '\uD83D\uDDD1\uFE0F',
    update_record_ttl: '\u23F1\uFE0F',
    toggle_proxy: '\u2601\uFE0F',
    check_dns_propagation: '\uD83C\uDF10'
};

function ToolExecutionCard({ execution }) {
    const [expanded, setExpanded] = useState(false);

    const label = TOOL_LABELS[execution.tool] || execution.tool;
    const icon = TOOL_ICONS[execution.tool] || '\u2699\uFE0F';

    const argsStr = Object.entries(execution.args || {})
        .map(([k, v]) => `${k}: ${v}`)
        .join(', ');

    return (
        <div className={`tool-card ${execution.success ? 'tool-success' : 'tool-error'}`}>
            <div
                className="tool-card-header"
                onClick={() => setExpanded(!expanded)}
            >
                <div className="tool-card-left">
                    <span className="tool-icon">{icon}</span>
                    <span className="tool-name">{label}</span>
                    {argsStr && <span className="tool-args">({argsStr})</span>}
                </div>
                <div className="tool-card-right">
                    <span className={`tool-status ${execution.success ? 'status-ok' : 'status-err'}`}>
                        {execution.success ? '\u2713' : '\u2717'}
                    </span>
                    <span className="tool-duration">{execution.duration}ms</span>
                    <span className="tool-expand">{expanded ? '\u25B2' : '\u25BC'}</span>
                </div>
            </div>
            {expanded && (
                <div className="tool-card-body">
                    <pre>{JSON.stringify(execution.result, null, 2)}</pre>
                </div>
            )}
        </div>
    );
}

export default ToolExecutionCard;
